module.exports = __webpack_public_path__ + "static/media/dollar-sign-with-circle.6167132f.svg";